import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';
import authService from '../../services/AuthService';
import ReactPlayer from 'react-player'

import './GettingStarted.css';

import cadeHeader from '../../content/CADEGettingStarted.png';
import stepByStep from '../../content/StepByStep.PNG';

/*
 * Welcome is responsible for providing a parent or pro specific welcome page and then allowing the user to navigate to the CADE Home page.
 */

export class GettingStarted extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }

    }


    render() {

        // Otherwise, get login credentials and try to authenticate
        return (
            <div class="GettingStartedWrapper">
                <Link to="/home"><img id="EnterCade" src={cadeHeader} className="cadeHeader" alt="CADE Header" title="Click to start using CADE" /></Link>

                
                <h2 className="gettingStarted_category">Welcome and Introduction to Clear Child CADE</h2>
                <p className="gettingStarted_helpText">Welcome! The following videos introduce you to Clear Child and the CADE system. When you're ready, jump into CADE by clicking the CADE icon in the top left corner.  You will then be offered additional product tours for each of the major CADE pages.</p>
                <CardDeck>
                    <Card >
                        <Card.Body>
                            <Card.Title>Dr. Marcy Welcome</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Why Clear Child?</Card.Subtitle>
                            <Card.Text>
                                <div class="gettingStarted_playerWrapper">
                                    <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/397054396/10764c1a59' controls={true} width='100%' height="100%" />
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>

                    <Card >
                        <Card.Body>
                            <Card.Title>Dr. Anna Welcome</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">How Clear Child Profiles Can Help</Card.Subtitle>
                            <Card.Text>
                                <div class="gettingStarted_playerWrapper">
                                    <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/397052176/cb79517baa' controls={true} width='100%' height="100%" />
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>

                    {authService.isParentAccount && false &&
                        <Card >
                            <Card.Body>
                                <Card.Title>Where To Go Next?</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Click the Image for Step-by-Step Instructions</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <a href="https://clearchildparent.com/cadestepbystep/" target="_blank" title="Step-by-Step instructions to start using CADE Assessments quickly">
                                            <img src={stepByStep} alt="Step-by-Step" title="Click for step-by-step instructions" />
                                        </a>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    }

                </CardDeck>
                <p className="gettingStarted_homePageLink"><Link to="/home">Click to start using CADE</Link></p>

                {authService.isParentAccount &&
                    <Fragment>
                    <h3 className="gettingStarted_category">Creating and Managing CADE Assessments</h3>
                    <CardDeck>

                        <Card >
                            <Card.Body>
                                <Card.Title>CADE Navigation</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Navigating the CADE Application</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/392300531/c10e4d736c' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card >
                            <Card.Body>
                                <Card.Title>Creating an Assessment</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">How to Create an Assessment</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/392299475/1dcd5ba85d' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card >
                            <Card.Body>
                                <Card.Title>Using Your Assessment</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Use an Assessment Once Created</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/412903319/6ac93d1539' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card >
                            <Card.Body>
                                <Card.Title>Archiving an Assessment</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Removing Unwanted Assessments</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/412902704/454de74898' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                    </CardDeck>
                    <p className="gettingStarted_homePageLink"><Link to="/home">Click to start using CADE</Link></p>

                    <h3 className="gettingStarted_category">Granting Access to Others</h3>
                    <CardDeck>
                        <Card >
                            <Card.Body>
                                <Card.Title>Working with Raters</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">How to Create a Rater</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/400672640/49d4c613ea' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card >
                            <Card.Body>
                                <Card.Title>Clinician Access to Assessments</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Clinician Assessment Instructions</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/412902163/282882adfe' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                    </CardDeck>
                    <p className="gettingStarted_homePageLink"><Link to="/home">Click to start using CADE</Link></p>

                    <h3 className="gettingStarted_category">Recommendations and the Clear Child Reading Room</h3>
                    <CardDeck>
                        <Card >
                            <Card.Body>
                                <Card.Title>Clear Child Recommendations</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">Understanding and Using Recommendations</Card.Subtitle>
                                <Card.Text>
                                    <div class="gettingStarted_playerWrapper">
                                        <ReactPlayer className="gettingStarted_player" url='https://vimeo.com/392520273/f614fc9f75' controls={true} width='100%' height="100%" />
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>


                    </CardDeck>
                    <p className="gettingStarted_homePageLink"><Link to="/home">Click to start using CADE</Link></p>
                    </Fragment>
                }
            </div>

        )
    }
}

export default GettingStarted;




// WEBPACK FOOTER //
// ./src/components/GettingStarted/GettingStarted.js